const { REACT_APP_PROXY_HOST } = process.env;

const construireUrl = (suffixe) => (REACT_APP_PROXY_HOST || '') + suffixe;

const lireErreurHttp = async (reponse) => {
  let message = 'Erreur inconnue';
  try {
    const contenu = await reponse.json();
    message = (contenu && (contenu.message || contenu.error)) || JSON.stringify(contenu);
  } catch (erreurJson) {
    try {
      message = await reponse.text();
    } catch (erreurTexte) {
      message = reponse.statusText || message;
    }
  }
  return message || ('Erreur HTTP ' + reponse.status);
};

const verifierHttp = async (reponse) => {
  if (!reponse.ok) {
    const message = await lireErreurHttp(reponse);
    throw new Error(message);
  }
  return reponse.json();
};

const adapterPayloadBackend = (payload) => {
  if (payload && payload.type === 'deploiement_synccam') {
    return payload;
  }

  const referenceVersion = (payload && payload.referenceVersion) || {};
  const validationsBaseDonnees = (payload && payload.validationsBaseDonnees) || {};
  const environnement = (payload && (payload.environnement || payload.environnementCible)) || '';
  const branche = (payload && payload.branche) || referenceVersion.branche || '';
  const commit = (payload && payload.commit) || referenceVersion.commit || '';
  const version = (payload && payload.version) || referenceVersion.version || '';
  const operateur = (payload && payload.operateur) || '';
  const migrationNecessaire = validationsBaseDonnees.migrationNecessaire || 'non_renseigne';
  const migrationSensible = validationsBaseDonnees.migrationSensible ? 'oui' : 'non';
  const rollbackPrepare = validationsBaseDonnees.rollbackPrepare ? 'oui' : 'non';

  return {
    ...payload,
    environnement,
    branche,
    commit,
    version,
    operateur,
    migrationPlan: {
      required: 'migration=' + migrationNecessaire + ';sensible=' + migrationSensible + ';rollback=' + rollbackPrepare,
    },
  };
};

const fetchAvecFallback = async (suffixes, options) => {
  let derniereReponse = null;
  for (let i = 0; i < suffixes.length; i += 1) {
    const suffixe = suffixes[i];
    const reponse = await fetch(construireUrl(suffixe), options);
    if (reponse.ok) {
      return reponse;
    }
    derniereReponse = reponse;
    if (reponse.status !== 404) {
      return reponse;
    }
  }
  return derniereReponse;
};

export const creerDeploiement = async (payload) => {
  const payloadBackend = adapterPayloadBackend(payload);
  const reponse = await fetchAvecFallback(['/ing/deploiements', '/ing/deploiement', '/ing/deploiements/'], {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payloadBackend),
  });
  if (!reponse) {
    throw new Error('Aucune reponse du backend.');
  }
  if (!reponse.ok) {
    const message = await lireErreurHttp(reponse);
    throw new Error(message + ' (Endpoint teste: /ing/deploiements. Verifiez REACT_APP_PROXY_HOST et la route backend.)');
  }
  return verifierHttp(reponse);
};

export const obtenirDeploiements = async () => {
  const reponse = await fetchAvecFallback(['/ing/deploiements', '/ing/deploiement', '/ing/deploiements/'], { method: 'GET' });
  if (!reponse) {
    throw new Error('Aucune reponse du backend.');
  }
  return verifierHttp(reponse);
};

export const obtenirDeploiementParId = async (id) => {
  const idEncode = encodeURIComponent(id);
  const reponse = await fetchAvecFallback(['/ing/deploiements/' + idEncode, '/ing/deploiement/' + idEncode], { method: 'GET' });
  if (!reponse) {
    throw new Error('Aucune reponse du backend.');
  }
  return verifierHttp(reponse);
};



// WEBPACK FOOTER //
// src/components/deploiements/deploiementApi.js